import { AxiosInstance } from 'axios';
import decode from 'jwt-decode';

import urlConstants from './constants/url.constants';

export enum Action {
  REQUESTED = 'Requested',
  RECEIVED = 'Received',
}

export type Event = {
  action: Action;
  method: string; // TODO: to avoid circular dependencies, this is a string, but ideally it should be of type ApiCommand
  'input-parameters': Record<string, ApiOptionsValue>;
  requestAuthId: string;
  source: string;
  timestamp: string;
  url: string;
};

type Auth0JWTToken = {
  iss: string; // token issuer
  sub: string; // Auth0 ID
  aud: string[]; // audience(s)
  iat: number; // issued at (epoch)
  exp: number; // expiration date/time (epoch)
  azp: string;
  scope: string; // Auth0 token scope
};

interface ScribePostProps {
  action: Action;
  method: string; // TODO: to avoid circular dependencies, this is a string, but ideally it should be of type ApiCommand
  httpClient: AxiosInstance;
  options: Record<string, ApiOptionsValue>;
  token: string;
  url: string;
}

const { postEvent } = urlConstants.scribe;

class Scribe {
  static post({
    action,
    method,
    httpClient,
    options = {},
    token,
    url,
  }: ScribePostProps): void {
    const decodedToken: Auth0JWTToken = decode(token);
    const body: Event = {
      action,
      method,
      'input-parameters': options,
      requestAuthId: decodedToken?.sub ?? '',
      source: 'MAUD',
      timestamp: new Date().toISOString(),
      url,
    };

    httpClient
      .post(postEvent, body, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .catch((error) => {
        console.error('Error posting event to scribe', error);
      });
  }

  static extractToken(authorizationHeader: string): string {
    const [bearer, token] = authorizationHeader.split(' ');
    if (bearer === 'Bearer' && !!token) {
      return token;
    }

    return '';
  }
}

export default Scribe;
